module.exports = __webpack_public_path__ + "static/media/employer.5fc51a84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/employer.svg
// module id = 538
// module chunks = 0